import { render, staticRenderFns } from "./selectidentity.vue?vue&type=template&id=f8ef5310&scoped=true"
import script from "./selectidentity.vue?vue&type=script&lang=js"
export * from "./selectidentity.vue?vue&type=script&lang=js"
import style0 from "./selectidentity.vue?vue&type=style&index=0&id=f8ef5310&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ef5310",
  null
  
)

export default component.exports